var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkenin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11146_5199)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.7689 9.4395V22.5677C30.7689 27.0992 27.0953 30.7728 22.5638 30.7728H9.4356C4.90404 30.7728 1.23047 27.0992 1.23047 22.5677V9.4395C1.23047 4.90794 4.90404 1.23438 9.4356 1.23438H22.5638C27.0953 1.23438 30.7689 4.90794 30.7689 9.4395Z",
    stroke: "#F4F6FB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33398 13.7812V23.559",
    stroke: "#F4F6FB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33247 10.6649C10.3143 10.6649 11.1102 9.86899 11.1102 8.88715C11.1102 7.90531 10.3143 7.10938 9.33247 7.10938C8.35063 7.10938 7.55469 7.90531 7.55469 8.88715C7.55469 9.86899 8.35063 10.6649 9.33247 10.6649Z",
    fill: "#F4F6FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.666 23.559V17.7813C22.666 15.5721 20.8751 13.7812 18.666 13.7812C16.4569 13.7812 14.666 15.5721 14.666 17.7813V23.559",
    stroke: "#F4F6FB",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11146_5199"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkenin);
export default __webpack_public_path__ + "static/media/linkenin.848856af33e35b390b988c0496676c59.svg";
export { ForwardRef as ReactComponent };